import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import React from "react";
import { TaxForm1099IA } from "./instantAnswersComponents/payments/TaxForm1099IA";
export var taxForm1099 = function taxForm1099(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return TAX_FORM_1099_TITLE(context, strictLocalize);
    },
    getDescription: function getDescription() {
      return TAX_FORM_1099_DESCRIPTION(context);
    }
  };
};
var TAX_FORM_1099_TITLE = function TAX_FORM_1099_TITLE(context, strictLocalize) {
  var brand = context.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return strictLocalize({
      id: "yBfxkT",
      defaultMessage: [{
        "type": 0,
        "value": "Toegang tot je 1099-belastingformulier"
      }]
    });
  }
  return strictLocalize({
    id: "u+EQ3Y",
    defaultMessage: [{
      "type": 0,
      "value": "Kwalificatiecriteria voor het 1099-K-formulier"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brand = context.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return {
      label: strictLocalize({
        id: "Y3mwyM",
        defaultMessage: "View Export & Taxes"
      }),
      getLink: function getLink() {
        return brandPortalAccountRoute({
          tab: "export-and-taxes"
        });
      }
    };
  }
  return undefined;
};
var TAX_FORM_1099_DESCRIPTION = function TAX_FORM_1099_DESCRIPTION(context) {
  var brand = context.brand;
  return /*#__PURE__*/React.createElement(TaxForm1099IA, {
    brand: brand
  });
};